import React, { useEffect, useState } from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import '../styles/swagger.css';

const SwaggerUIComponent = () => {
  const [swaggerSpec, setSwaggerSpec] = useState(null);

  useEffect(() => {
    const fetchSpecs = async () => {
      try {
        const loginApi = await fetch('/login-api.json').then((res) => res.json()).catch(() => null);
        const templateApi = await fetch('/create-template-api.json').then((res) => res.json()).catch(() => null);
        const waTemplatesApi = await fetch('/get-wa-templates.json').then((res) => res.json()).catch(() => null);
        const getTemplatesApi = await fetch('/get-templates.json').then((res) => res.json()).catch(() => null);
        const waReportApi = await fetch('/get-wa-report.json').then((res) => res.json()).catch(() => null);
        const waReportStatusApi = await fetch('/get-wa-report-status.json').then((res) => res.json()).catch(() => null);
        const userBalanceApi = await fetch('/get-user-balance.json').then((res) => res.json()).catch(() => null);
        const uploadMediaApi = await fetch('/upload-media.json').then((res) => res.json()).catch(() => null);
        const permanentTokenApi = await fetch('/permanent-token-api.json').then((res) => res.json()).catch(() => null);
        const catalogApi = await fetch('/whatsapp-catalog-api.json').then((res) => res.json()).catch(() => null);
        const botBuilderApi = await fetch('/bot-builder-api.json').then((res) => res.json()).catch(() => null);

        const combinedSpec = {
          openapi: '3.0.0',
          info: {
            title: 'API Documentation',
            version: '1.0.0',
            description: 'API Documentation for Messaging Alerts Integration',
          },
          servers:
            loginApi?.servers ||
            templateApi?.servers ||
            waTemplatesApi?.servers ||
            getTemplatesApi?.servers ||
            waReportApi?.servers ||
            waReportStatusApi?.servers ||
            userBalanceApi?.servers ||
            uploadMediaApi?.servers ||
            permanentTokenApi?.servers ||
            catalogApi?.servers ||
            botBuilderApi?.servers,
          components: {
            securitySchemes: {
              ...(loginApi?.components?.securitySchemes || {}),
              ...(templateApi?.components?.securitySchemes || {}),
              ...(waTemplatesApi?.components?.securitySchemes || {}),
              ...(getTemplatesApi?.components?.securitySchemes || {}),
              ...(waReportApi?.components?.securitySchemes || {}),
              ...(waReportStatusApi?.components?.securitySchemes || {}),
              ...(userBalanceApi?.components?.securitySchemes || {}),
              ...(uploadMediaApi?.components?.securitySchemes || {}),
              ...(permanentTokenApi?.components?.securitySchemes || {}),
              ...(catalogApi?.components?.securitySchemes || {}),
              ...(botBuilderApi?.components?.securitySchemes || {}),
            },
            schemas: {
              ...(loginApi?.components?.schemas || {}),
              ...(templateApi?.components?.schemas || {}),
              ...(waTemplatesApi?.components?.schemas || {}),
              ...(getTemplatesApi?.components?.schemas || {}),
              ...(waReportApi?.components?.schemas || {}),
              ...(waReportStatusApi?.components?.schemas || {}),
              ...(userBalanceApi?.components?.schemas || {}),
              ...(uploadMediaApi?.components?.schemas || {}),
              ...(permanentTokenApi?.components?.schemas || {}),
              ...(catalogApi?.components?.schemas || {}),
              ...(botBuilderApi?.components?.schemas || {}),
            },
          },
          security:
            loginApi?.security ||
            templateApi?.security ||
            waTemplatesApi?.security ||
            getTemplatesApi?.security ||
            waReportApi?.security ||
            waReportStatusApi?.security ||
            userBalanceApi?.security ||
            uploadMediaApi?.security ||
            permanentTokenApi?.security ||
            catalogApi?.security ||
            botBuilderApi?.security,
          tags: [
            ...(loginApi?.tags || []),
            ...(templateApi?.tags || []),
            ...(waTemplatesApi?.tags || []),
            ...(getTemplatesApi?.tags || []),
            ...(waReportApi?.tags || []),
            ...(waReportStatusApi?.tags || []),
            ...(userBalanceApi?.tags || []),
            ...(uploadMediaApi?.tags || []),
            ...(permanentTokenApi?.tags || []),
            ...(catalogApi?.tags || []),
            ...(botBuilderApi?.tags || []),
          ],
          paths: {
            ...loginApi?.paths,
            ...templateApi?.paths,
            ...waTemplatesApi?.paths,
            ...getTemplatesApi?.paths,
            ...waReportApi?.paths,
            ...waReportStatusApi?.paths,
            ...userBalanceApi?.paths,
            ...uploadMediaApi?.paths,
            ...permanentTokenApi?.paths,
            ...catalogApi?.paths,
            ...botBuilderApi?.paths,
          },
        };

        const envApiUrl = process.env.REACT_APP_API_BASE_URL;
        if (envApiUrl) {
          combinedSpec.servers = [
            { url: envApiUrl, description: 'Base URL for API' },
          ];
        }

        setSwaggerSpec(combinedSpec);
      } catch (error) {
        console.error('Error loading API specs:', error);
      }
    };

    fetchSpecs();
  }, []);

  return swaggerSpec ? (
    <SwaggerUI spec={swaggerSpec} />
  ) : (
    <p>Loading API documentation...</p>
  );
};

export default SwaggerUIComponent;
